module.exports = __webpack_public_path__ + "img/gg.6506cc04.svg";